import { GlobalEnvironment as CAEGlobalEnvironment, ServerType, EnvironmentType } from "@cae/component-library";

export class GlobalEnvironment {

    static GetUrl_API(isHTTPS?: boolean): string {        
        const PROTOCOL: string = isHTTPS === undefined ? "//" : isHTTPS ? "https://" : "http://";
        const serverType: ServerType = CAEGlobalEnvironment.GetEnvironmentType();

        if (serverType.type === EnvironmentType.Dev) {
            return "https://hubslogbookservice-mfg-hubslogbook-dev.apps.devgw.cluster.devcloud.cae.com/"
       }
       else if (serverType.type === EnvironmentType.PreProd) {
            return "https://hubslogbookservice-mfg-hubslogbook-qas.apps.devgw.cluster.devcloud.cae.com/"
       }
       else if (serverType.type === EnvironmentType.Prod) {
            return "https://hubslogbookservice-mfg-hubslogbook-prd.apps.prdgw.cluster.cloud.cae.com/"
       } else {
           return PROTOCOL + window.location.hostname + ':61483/';
       }
    }
}
